import React from 'react';
import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TypographyInfoStyled = styled(Typography)`
  font-size: 9px;
`;

const InfoOutlinedIconStyled = styled(InfoOutlinedIcon)`
  width: 16px;
  vertical-align: middle;
  margin-right: 4px;
  @media (max-width: 600px) {
    width: 12px;
  }
`;

interface InfoTextProps {
  children: React.ReactNode;
}

const InfoText: React.FC<InfoTextProps> = ({ children }) => (
  <TypographyInfoStyled variant="body2" gutterBottom>
    <InfoOutlinedIconStyled fontSize="small" />
    {children}
  </TypographyInfoStyled>
);

export default InfoText;